module.exports = __webpack_public_path__ + "assets/img/page2-side-nav-neutral-af69ac94.png";